import React from 'react';
import { Link } from 'react-router-dom';

const Odnosnik = ({tekst, link}) => {
    return (
        <div className='w-screen font-sen text-[2rem] md:text-[5rem] lg:text-[9rem] transition-all duration-300 '>
            <a id='link' href={link} className='before:translate-y-1/2'>{tekst}</a>
        </div>
    );
}

export default Odnosnik;
